export default "__VITE_ASSET__ce9e6466__"